

import React from "react";
import Table from "./Table/index";

export default function AdsPlacement() {
  return (
    <div>
      <Table />
    </div>
  );
}
